export function OutlineEstatusProyectoIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.4563 0.75V3.3056C20.4563 3.50307 20.6132 3.65989 20.798 3.65989H23.2461"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0356 9.2644V1.55153C12.0356 1.11011 12.383 0.75 12.8087 0.75H20.573C20.7802 0.75 20.9819 0.837123 21.1275 0.988135L23.0266 2.98615C23.1722 3.13716 23.2507 3.34044 23.2507 3.54954V14.6606H23.2451C23.2451 15.102 22.8977 15.4621 22.472 15.4621H19.4144"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.75 17.7796H2.77364L3.78862 20.8793L6.82723 12.3613L8.85718 23.1978L11.8958 14.6861L12.9108 17.7796H14.9344"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
